import { render, staticRenderFns } from "./supervisorTheAssessment.vue?vue&type=template&id=76f2e6c6&scoped=true&"
import script from "./supervisorTheAssessment.vue?vue&type=script&lang=js&"
export * from "./supervisorTheAssessment.vue?vue&type=script&lang=js&"
import style0 from "./supervisorTheAssessment.vue?vue&type=style&index=0&id=76f2e6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f2e6c6",
  null
  
)

export default component.exports